import { LocationsProvider } from "domain/Location";
import { SmallInventoryValueProvider } from "domain/SmallInventoryValue";
import { SortingProvider } from "domain/Sorting";
import { SuppliersProvider } from "domain/Supplier/context";
import { AmortizationTypeProvider } from "domain/AmortizationType";
import { CategoriesProvider } from "domain/Category";
import { CensusProvider } from "domain/Census";
import { CompaniesProvider } from "domain/Company";
import { EmployeesProvider } from "domain/Employee";
import { FiltersProvider } from "domain/Filters";
import { HistoryProvider } from "domain/History";
import { InventoryPaginationProvider } from "domain/Inventory";

export const WarehousePageProvider = ({children}) => (
      <SortingProvider>
        <LocationsProvider>
          <FiltersProvider>
            <CategoriesProvider>
              <CompaniesProvider>
                <CensusProvider>
                  <SuppliersProvider>
                    <EmployeesProvider>
                      <SmallInventoryValueProvider>
                        <AmortizationTypeProvider>
                          <HistoryProvider>
                            <InventoryPaginationProvider>{children}</InventoryPaginationProvider>
                          </HistoryProvider>
                        </AmortizationTypeProvider>
                      </SmallInventoryValueProvider>
                    </EmployeesProvider>
                  </SuppliersProvider>
                </CensusProvider>
              </CompaniesProvider>
            </CategoriesProvider>
          </FiltersProvider>
        </LocationsProvider>
      </SortingProvider>
)